export * from './local-storage/local-storage.service';
export * from './animations/route.animations';
export * from './animations/animations.service';
export * from './core.module';

